<template>
  <Teleport to="body">
    <div
      v-if="showSuggestions && suggestions.length > 0"
      :id="pickerId + suggestionSuffix"
      class="suggestions-dropdown"
      :style="dropdownStyle"
      role="listbox"
      @mousedown.prevent
    >
      <div
        v-for="(suggestion, index) in suggestions"
        :id="pickerId + optionSuffix + index"
        :key="suggestion.key || suggestion.id || index"
        :class="['suggestion-item', { 'highlighted': index === highlightedIndex }]"
        role="option"
        :aria-selected="index === highlightedIndex ? 'true' : null"
        @mousedown.prevent="$emit('select-suggestion', suggestion)"
        @mouseenter="$emit('update-highlighted', index)"
      >
        <span class="vue-simple-picker-label">{{ suggestion.label }}</span>
        <span
          v-if="showcode && suggestion.code"
          class="vue-simple-picker-code"
        >
          {{ suggestion.code }}
        </span>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'SuggestionsDropdown',
  props: {
    pickerId: {
      type: String,
      required: true,
    },
    showSuggestions: {
      type: Boolean,
      required: true,
    },
    suggestions: {
      type: Array,
      required: true,
    },
    highlightedIndex: {
      type: Number,
      required: true,
    },
    dropdownStyle: {
      type: Object,
      required: true,
    },
    dropdowntype: {
      type: String,
      default: null,
    },
    suggestionSuffix: {
      type: String,
      default: '-suggestions',
    },
    optionSuffix: {
      type: String,
      default: '-option-',
    },
    showcode: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['select-suggestion', 'update-highlighted'],
};
</script>
